import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import SectionHeaderLayout from "../../common/components/SectionHeaderLayout";
import RedirectionHandler from "../../common/handlers/RedirectionHandler";
import SectionItem from "./subComponent/SectionItem";
import { ServiceSectionContent } from "./types";
import { componentNameConstants } from "@repo/analytics/data-layer.constants";

const ServiceSection = ({ content }: { content: ServiceSectionContent }) => {
  const { headerName, list } = content;
  const objValueList = Object.values(list);

  return (
    <SectionHeaderLayout header={headerName}>
      <div className={`flex gap-[16px] max-md:gap-[8px]`}>
        {
          objValueList?.map((el, idx) => <RedirectionHandler
            url={isOpenInApp() ? el.appdataurl : el.webdataurl} key={idx}
            cta_text={el?.cardTitle} section_title={componentNameConstants.ADITIONAL_SERVICES}
            isLoginRequired={el?.isLoginRequired ?? "false"}
          >
            <SectionItem url={isOpenInApp() ? el.mobileImage : el.desktopimage} title={el.cardTitle} description={el.description} />
          </RedirectionHandler>)
        }
      </div>
    </SectionHeaderLayout>
  );
};

export default ServiceSection;